module["exports"] = [
  "#{Name.last_name}#{street_suffix}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/zh_CN/address/street_name.js
// module id = 1988
// module chunks = 0